import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

if (!API_URL) {
  console.error('REACT_APP_BACKEND_URL environment variable is not set');
}

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Export API_URL for use in components that need direct URL access
export const getApiUrl = () => API_URL;

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bms-admin-token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('bms-admin-token');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
